/*
 * Atelier "Customize / Made-to-Order" form — lead tracking + CDP identify.
 *
 * The customize form (Shopify Forms app, form_id 577341, e.g. on
 * /pages/the-atelier) renders inside open shadow roots:
 *     <shopify-forms-embed>  ->  <shop-lead-capture>
 * and its submit is handled by the app's own JS inside that shadow DOM.
 *
 * HISTORY — v1 (click detection) NEVER FIRED IN PRODUCTION. It watched for a
 * capture-phase click on an in-shadow submit button. By 2026-08-31 the
 * customize_form_submitted table had 0 rows all-time, and the 2026-08-27 NZ
 * custom-saree lead (jareenfahmi@) produced no track and no identify — the
 * generic click-based email capture in rudderstack-direct.js missed it too.
 * Whatever the app's current submit flow is (Enter key, non-BUTTON element,
 * re-rendered markup), click detection does not see it.
 *
 * v2 — submit-proof, two parts:
 *   1. CAPTURE: 'input' events are composed:true, so they cross open shadow
 *      boundaries. One capture-phase listener on document reads the field
 *      being typed into (composedPath()[0]) whenever it's inside a
 *      <shopify-forms-embed>, and mirrors email/phone/description into
 *      sessionStorage as the visitor types. No submit detection needed.
 *   2. CONFIRM: the Forms app redirects to /pages/form-filled ONLY after a
 *      successful submit (verified: the 2026-08-27 lead's form-filled
 *      pageview matches the Shopify customer created_at to the second).
 *      Landing there with a fresh capture = a confirmed submit. Fire:
 *        - window.rudderIdentify({email, phone})       -> joins this visitor's
 *          anonymous browse/cart history to a person in the warehouse
 *        - window.rudderTrack('customize_form_submitted', {...})
 *        - fbq('track', 'Lead')                        -> a conversion Meta
 *          can see and optimise toward
 *      The capture is cleared after firing (refresh-safe) and expires after
 *      30 minutes (stale-tab safe). Direct visits to /pages/form-filled with
 *      no capture do nothing.
 *
 * ponytail: browser autofill that skips 'input' events (rare, old Safari)
 * won't be captured — upgrade path is a polling read of the shadow fields.
 */
(function () {
  if (typeof window === 'undefined') return;
  if (window.__atelierFormTrack) return; // idempotent
  window.__atelierFormTrack = true;

  var FORM_ID = '577341';
  var KEY = 'rk_atelier_capture';
  var MAX_AGE_MS = 30 * 60 * 1000;

  function inEmbed(path) {
    for (var i = 0; i < path.length; i++) {
      if (path[i] && path[i].tagName === 'SHOPIFY-FORMS-EMBED') return true;
    }
    return false;
  }

  /* ---- 1. Capture: mirror form fields into sessionStorage as typed ---- */
  document.addEventListener('input', function (evt) {
    try {
      var path = evt.composedPath ? evt.composedPath() : [];
      if (!path.length || !inEmbed(path)) return;
      var f = path[0]; // innermost target = the actual field in the shadow DOM
      if (!f || typeof f.value !== 'string') return;
      if (f.name === 'h-captcha-response') return; // not a user field

      var data = {};
      try { data = JSON.parse(sessionStorage.getItem(KEY) || '{}'); } catch (e) {}
      var v = f.value.trim();
      // The app's email input is type="text" with NO name (verified live
      // 2026-08-31) — only id="email" and inputmode="email" identify it.
      // Match loosely across type/name/id/inputmode so app markup drift
      // doesn't silently kill capture again.
      var key = (f.name || '') + ' ' + (f.id || '');
      if (f.type === 'email' || /email/i.test(key) ||
          (f.getAttribute && f.getAttribute('inputmode') === 'email')) data.email = v;
      if (f.type === 'tel' || /phone/i.test(key)) data.phone = v;
      if (key.indexOf('custom#description') !== -1) data.description = v;
      if (/first_name/i.test(key)) data.name = v;
      data.ts = Date.now();
      data.page = window.location.pathname;
      sessionStorage.setItem(KEY, JSON.stringify(data));
    } catch (e) { /* never break the page for analytics */ }
  }, true); // capture phase — input events compose through open shadow roots

  /* ---- 2. Confirm: the post-submit redirect page fires the events ---- */
  function fireIfSubmitted() {
    try {
      if (window.location.pathname.indexOf('/pages/form-filled') !== 0) return;
      var raw = sessionStorage.getItem(KEY);
      if (!raw) return;
      sessionStorage.removeItem(KEY); // fire at most once per capture
      var data = JSON.parse(raw);
      if (!data.ts || Date.now() - data.ts > MAX_AGE_MS) return;

      var phoneDigits = ((data.phone || '').match(/\d/g) || []).length;
      var emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email || '');
      // The phone field is pre-seeded with a dial code, so require a real
      // subscriber number (>= 7 digits) or a valid email before firing.
      if (!emailOk && phoneDigits < 7) return;

      if (emailOk && typeof window.rudderIdentify === 'function') {
        var traits = { email: data.email };
        if (phoneDigits >= 7) traits.phone = data.phone;
        if (data.name) traits.firstName = data.name;
        window.rudderIdentify(traits);
      }
      if (typeof window.rudderTrack === 'function') {
        window.rudderTrack('customize_form_submitted', {
          form_id: FORM_ID,
          form_name: 'Atelier Customize',
          page: data.page || '/pages/the-atelier',
          has_email: emailOk,
          has_phone: phoneDigits >= 7,
          has_description: !!data.description
        });
      }
      if (typeof window.fbq === 'function') {
        window.fbq('track', 'Lead', {
          content_name: 'Atelier Customize Form',
          content_category: 'made-to-order'
        });
      }
    } catch (e) { /* never break the page for analytics */ }
  }
  fireIfSubmitted();
})();
